import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyBacklogRoute: InvariantJiraRoute = {
	name: 'legacy-backlog',
	path: '/secure/RapidBoard.jspa',
	query: ['rapidView', 'view=(.*planning.*)'],
};
